import React from "react";
import { ActiveTab } from "../types";

interface Props {
  activeTab: ActiveTab;
  livesCount: number;
  onChange: (activeTab: ActiveTab) => void;
}

const TabButton = ({
  activeTab,
  icon,
  label,
  onChange,
  tab,
}: {
  activeTab: ActiveTab;
  icon: string;
  label: string;
  onChange: (activeTab: ActiveTab) => void;
  tab: ActiveTab;
}) => (
  <button
    className="tab"
    role="tab"
    id={`tab-${tab}`}
    aria-controls={`panel-${tab}`}
    aria-selected={activeTab === tab}
    type="button"
    onClick={() => onChange(tab)}
  >
    <svg aria-hidden="true">
      <use href={`#${icon}`} />
    </svg>
    <span className="t-label">{label}</span>
  </button>
);

const Tabs = ({ activeTab, livesCount, onChange }: Props) => (
  <div className="container tabwrap">
    <div className="tabs" role="tablist" aria-label="Course sections">
      <TabButton
        activeTab={activeTab}
        icon="ic-book"
        label="Chapters"
        onChange={onChange}
        tab="chapters"
      />
      <TabButton
        activeTab={activeTab}
        icon="ic-shelf"
        label="Resources"
        onChange={onChange}
        tab="resources"
      />
      <button
        className="tab"
        role="tab"
        id="tab-lives"
        aria-controls="panel-lives"
        aria-selected={activeTab === "lives"}
        type="button"
        onClick={() => onChange("lives")}
      >
        <svg aria-hidden="true">
          <use href="#ic-heart" />
        </svg>
        <span className="t-label">Lives</span>
        <span className="lives-count" aria-hidden="true">
          {livesCount || 0}
        </span>
      </button>
    </div>
  </div>
);

export default Tabs;
